/* eslint-disable */
import './it-it'

class DewTranslator
{
    constructor(dictionary)
    {
        this.dictionary = dictionary;
        this.locale = 'it-it'
    }
    
    getString(key, values)
    {
        let temp = this.dictionary[key] !== undefined ? this.dictionary[key] : key;    
        if (values !== undefined)
        {
            let result = ''
            temp = this.dictionary[key] !== undefined ? this.dictionary[key] : key;        
            for (let index = 0; index < values.length; index++) {
                const element = values[index];
                temp = temp.replace(/{[0-9]+}/i,element);
            }
        }
        return temp
    }
    changeDictionary(dictionary, loc)
    {
        this.dictionary = new Set();
        this.locale = loc
    }
}

export default DewTranslator;


// WEBPACK FOOTER //
// ./src/localization/translator.js